export enum StoreProductMode {
  PRODUCT_WIZARD = 'product_wizard',
  PRODUCT_TEMPLATE_WIZARD = 'product_template_wizard',
  PRODUCT_WIZARD_BULK_CONNECT = 'product_wizard_bulk_connect',
  CONNECT_VARIANT = 'connect_variant',
}
